/**
 * @ngdoc service
 * @name picklists.factory:RsvpSeatplanElement
 *
 * @description
 *
 */
angular
    .module('festzelt-os.seatplans')
    .factory('RsvpSeatplanElement', [
        'locale',
        'Resource',
        RsvpSeatplanElement
    ]);

function RsvpSeatplanElement(locale, Resource) {
    const $model = Resource.make('rsvps/seatplan-elements');

    $model.locales = ['common', 'seatplans'];
    $model.schema = locale.ready($model.locales).then(function () {
        return {
            type: 'object',
            title: locale.getString('seatplans.groups.title'),
            properties: {
                id: {
                    title: locale.getString('common.id'),
                    type: 'number',
                    listview: 'hidden',
                    mergeable: false
                },
                pax: {
                    title: locale.getString('seatplans.groups.fields.title'),
                    type: 'integer',
                    columnDef: {
                        column_size: 'size-large',
                        main: true
                    }
                }
            },
            required: ['title']
        };
    });

    return $model;
}



// WEBPACK FOOTER //
// ./src/app/pages/seatplans/factories/rse-factory.js